import { useEffect } from "react";

const useClearCache = () => {
  useEffect(() => {
    if (typeof caches !== "undefined") {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }
  }, []);
};

export default useClearCache;
